
<div class="grid">
  <div class="col-8">
    <h2>Statistiche Totali</h2>
  </div>
  <div class="col-4 ">
    <label for="anni">Anno di riferimento: </label>
    <p-dropdown id="anni" [options]="anniDisponibili" [(ngModel)]="annoSelezionato" (onChange)="changeYear()" optionLabel="display" optionValue="value" placeholder="Tutti">
    </p-dropdown>
  </div>
  </div>
@if (inCarico) {
  <div class="grid">
    <div class = "col-12 xl:col-6">
      <table class="table" *ngIf="1 as tabellaid">
        <caption><h3>Documenti In carico - Arrivi</h3></caption>
        <tr>
          <td>qualifica/classifica</td>
          <th *ngFor="let classifica of classifiche" scope="col">
            <span>{{classifica.nomeClassifica}}</span>
          </th>
        </tr>
        <tr *ngFor="let qualifica of qualifiche">
          <th [id]=qualifica.qualificaId>
            <span>{{qualifica.nomeQualifica}}</span>
          </th>
          <td *ngFor="let classifica of classifiche">
            <ng-container *ngIf="getCount(tabellaid, inCarico, qualifica.qualificaId, classifica.classificaId, true) as count; else zero">
              <span [ngClass]="'count'">{{count}}</span>
            </ng-container>
            <ng-template #zero >
              <span [ngClass]="'zerocount'">0</span>
            </ng-template>
          </td>
        </tr>
      </table>
    </div>
    <div class = "col-12 xl:col-6">
      <table class="table" *ngIf="2 as tabellaid">
        <caption><h3>Documenti In carico - Partenze</h3></caption>
        <tr>
          <td>qualifica/classifica</td>
          <th *ngFor="let classifica of classifiche" scope="col">
            <span>{{classifica.nomeClassifica}}</span>
          </th>
        </tr>
        <tr *ngFor="let qualifica of qualifiche">
          <th>
            <span>{{qualifica.nomeQualifica}}</span>
          </th>
          <td *ngFor="let classifica of classifiche">
            <ng-container *ngIf="getCount(tabellaid, inCarico, qualifica.qualificaId, classifica.classificaId, false) as count; else zero">
              <span [ngClass]="'count'">{{count}}</span>
            </ng-container>
            <ng-template #zero >
              <span [ngClass]="'zerocount'">0</span>
            </ng-template>
          </td>
        </tr>
      </table>
  </div>
  </div>
}
<div style="padding: 10px;"></div>
@if (versati && distrutti) {
  <div class="grid">
  <div class = "col-12 xl:col-6">
    <table class="table" *ngIf="3 as tabellaid">
      <caption><h3>Documenti Versati</h3></caption>
      <tr>
        <td>qualifica/classifica</td>
        <th *ngFor="let classifica of classifiche" scope="col">
          <span>{{classifica.nomeClassifica}}</span>
        </th>
      </tr>
      <tr *ngFor="let qualifica of qualifiche">
        <th>
          <span>{{qualifica.nomeQualifica}}</span>
        </th>
        <td *ngFor="let classifica of classifiche">
          <ng-container *ngIf="getCount(tabellaid, versati, qualifica.qualificaId, classifica.classificaId) as count; else zero">
            <span [ngClass]="'count'">{{count}}</span>
          </ng-container>
          <ng-template #zero >
            <span [ngClass]="'zerocount'">0</span>
          </ng-template>
        </td>
      </tr>
    </table>
  </div>
  <div class = "col-12 xl:col-6">
    <table class="table" *ngIf="4 as tabellaid">
      <caption><h3>Documenti Distrutti</h3></caption>
      <tr>
        <td>qualifica/classifica</td>
        <th *ngFor="let classifica of classifiche" scope="col">
          <span>{{classifica.nomeClassifica}}</span>
        </th>
      </tr>
      <tr *ngFor="let qualifica of qualifiche">
        <th>
          <span>{{qualifica.nomeQualifica}}</span>
        </th>
        <td *ngFor="let classifica of classifiche">
          <ng-container *ngIf="getCount(tabellaid, distrutti, qualifica.qualificaId, classifica.classificaId) as count; else zero">
            <span [ngClass]="'count'">{{count}}</span>
          </ng-container>
          <ng-template #zero >
            <span [ngClass]="'zerocount'">0</span>
          </ng-template>
        </td>
      </tr>
    </table>
</div>
  </div>
}
<div style="padding: 10px;"></div>
@if (declassificati) {
  <div class="grid">
  <div class = "col-12 xl:col-6">
    <table class="table" *ngIf="5 as tabellaid">
      <caption><h3>Documenti Declassificati</h3></caption>
      <tr>
        <td>qualifica/classifica</td>
        <th *ngFor="let classifica of classifiche" scope="col">
          <span>{{classifica.nomeClassifica}}</span>
        </th>
      </tr>
      <tr *ngFor="let qualifica of qualifiche">
        <th>
          <span>{{qualifica.nomeQualifica}}</span>
        </th>
        <td *ngFor="let classifica of classifiche">
          <ng-container *ngIf="getCount(tabellaid, declassificati, qualifica.qualificaId, classifica.classificaId) as count; else zero">
            <span [ngClass]="'count'">{{count}}</span>
          </ng-container>
          <ng-template #zero >
            <span [ngClass]="'zerocount'">0</span>
          </ng-template>
        </td>
      </tr>
    </table>
  </div>
  </div>
}


